<soft-query-bar-item [value]="value()"
                     [title]="title()"
                     [icon]="icon()"
                     [clearable]="clearable()"
                     (onClick)="onClick()"
                     (clear)="onClear()">
  <ng-template>
    {{ (value() | optionLabel:options())() }}
  </ng-template>
</soft-query-bar-item>

